import momentTimezone from "moment-timezone";
import config from "config";

const moment = (time?: string | number) =>
  momentTimezone(time).tz(config.timezone);
export default moment;
